<template>
    <div id="app" v-loading.fullscreen.lock="showLoading">
        <topBar ref="topbar"></topBar>
        <div class="main-container" :class="{'no-slidebar':!slidebarEnabled, 'shrink-slidebar' : shrinkSlidebar}">
            <sideBar v-if="slidebarEnabled"></sideBar>
            <div class="main-wrapper">
                <div class="main" :class="{'kefu-main':isKefu}">
                    <router-view></router-view>
                </div>
            </div>
        </div>
        <AuthRequired></AuthRequired>
        <CheckPassword></CheckPassword>
    </div>
</template>

<script type="text/ecmascript-6">
    import TopBar from './layout/TopBar.vue'
    import SideBar from './layout/SideBar.vue'
    import AuthRequired from './modules/account/AuthRequiredDlg.vue'
    import CheckPassword from './modules/account/CheckPassword.vue'
    import {mapState, mapActions} from 'vuex'

    export default {
        name: 'app',
        components: {TopBar, SideBar, AuthRequired, CheckPassword},
        data () {
            return {
                showLoading: false,
                shrinkSlidebar: false,
            }
        },
        computed: {
            ...mapState([
                'showMask',
                'showSlidebar',
                'COMMON',
                'isKefu'
            ]),
            slidebarEnabled(){
                return this.COMMON && this.COMMON.user && this.showSlidebar && !this.isKefu;
            }
        },
        mounted(){
            this.computeLoading()
        },
        methods:{
            computeLoading(){
                if (this.showMask) {
                    setTimeout(() => {
                        if (this.showMask) {
                            this.showLoading = true;
                        } else {
                            this.showLoading = false;
                        }
                    }, 1000);
                } else {
                    this.showLoading = false;
                }
            }
        },
        watch: {
            showMask(newVal){
                this.computeLoading()
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    #app, body, html {
        height: 100%;
    }

    .el-loading-mask{
        background-color: #000;
        opacity: 0.8;
    }

    body, html {
        margin: 0;
        padding: 0;
    }

    body {
        background-color: #f4f4f4;
    }

    #app {
        min-width: 1000px;
        > .main-container {
            padding: 0;
            position: absolute;
            bottom: 0;
            top: 50px;
            left: 0;
            right: 0;
            transition: left 0.3s;
            > .main-wrapper {
                height: 100%;
                position: absolute;
                bottom: 0;
                top: 0;
                left: 200px;
                right: 0;
                > .main {
                    background: #fff;
                    height: 100%;
                    overflow-y: auto;
                    padding: 1px 20px;
                }
                > .kefu-main{
                    padding: 0;
                }
            }
        }
        > .main-container.no-slidebar {
            left: -200px;
        }
        > .main-container.shrink-slidebar {
            left: -200px;
        }
    }

    /*----- 滚动条谷歌 -------*/
    ::-webkit-scrollbar-track {
        background-color: rgba(0, 0, 0, 0.2);
    }

    ::-webkit-scrollbar {
        width: 6px;
        height: 8px;
        background-color: #F5F5F5;
        border-radius: 5px;
    }

    ::-webkit-scrollbar-thumb { /* */
        background: gray;
        border-radius: 5px;
    }

    ::-webkit-scrollbar-corner {
        background-color: #F5F5F5;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue